export default function getDefaultState () {
  return {
    clients: {},
    loadingAll: false,
    loadingInvoices: false,
    allInvoicesDownloading: false,
    allQuotationsDownloading: false
  }
}
